import { TbArrowDownLeft, TbArrowUpRight, TbHistory, TbUsers } from "react-icons/tb";
import intl from "react-intl-universal";
import { ShortcutCard } from "../../../../Components/Atoms/ShortcutCard";
import {
  CROSSBORDER_CUSTOMERS_PATH,
  CROSSBORDER_HOME_PATH,
} from "../constants";

export const CrossborderShortcutMenu = ({
  onOpenPayin,
  onOpenPayout,
  homePath = CROSSBORDER_HOME_PATH,
  customersPath = CROSSBORDER_CUSTOMERS_PATH,
  showCustomers = true,
  canMutate = true,
}) => {
  const items = [
    {
      id: "history",
      labelKey: "crossborder.history",
      icon: TbHistory,
      path: homePath,
    },
    ...(canMutate
      ? [
          {
            id: "payin",
            labelKey: "crossborder.payin",
            icon: TbArrowDownLeft,
            onClick: onOpenPayin,
          },
          {
            id: "payout",
            labelKey: "crossborder.payout",
            icon: TbArrowUpRight,
            onClick: onOpenPayout,
          },
        ]
      : []),
    ...(showCustomers
      ? [
          {
            id: "customers",
            labelKey: "crossborder.customers.title",
            icon: TbUsers,
            path: customersPath,
          },
        ]
      : []),
  ];

  return (
    <section className="mb-5 min-w-0 overflow-hidden">
      <h2 className="mb-3 text-sm font-bold text-brand-dark dark:text-gray-100">
        {intl.get("crossborder.quickActions")}
      </h2>
      <div className="shortcut-scroll-row">
        {items.map(({ id, labelKey, icon, path, onClick }) => (
          <ShortcutCard
            key={id}
            to={path}
            onClick={onClick}
            icon={icon}
            label={intl.get(labelKey)}
          />
        ))}
      </div>
    </section>
  );
};
